import { call, put, select } from "redux-saga/effects"

import {
  ADD_AWARD_NOMINATION_SUCCESS,
  ADD_AWARD_NOMINATION_FAILURE,
  CREATE_ORDER_AWARD_NOMINATION_SUCCESS,
  CREATE_ORDER_AWARD_NOMINATION_FAILURE,
  VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS,
  VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE,
  GET_AWARD_DETAILS_SUCCESS,
  GET_AWARD_DETAILS_FAILURE,
  GET_AWARDS_LIST_SUCCESS,
  GET_AWARDS_LIST_FAILURE,
  GET_NOMINATION_LIST_SUCCESS,
  GET_NOMINATION_LIST_FAILURE,
  GET_NOMINATION_DETAILS_SUCCESS,
  GET_NOMINATION_DETAILS_FAILURE,
  GET_AWARDS_CATEGORY_LIST_SUCCESS,
  GET_AWARDS_CATEGORY_LIST_FAILURE,
  UPDATE_NOMINATION_SUCCESS,
  UPDATE_NOMINATION_FAILURE,
  ADD_AWARD_SHORTLISTED_DETAILS_FAILURE,
  ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS,
  ADD_AWARD_SUCCESS,
  ADD_AWARD_FAILURE,
  UPDATE_AWARD_SUCCESS,
  UPDATE_AWARD_FAILURE,
  ADD_AWARD_CATEGORY_SUCCESS,
  ADD_AWARD_CATEGORY_FAILURE,
  UPDATE_AWARD_CATEGORY_SUCCESS,
  UPDATE_AWARD_CATEGORY_FAILURE,
} from "../../types/awards"

import awardsApi from "../../../api/awards"

const getAuthToken = state => state.auth.token

export function* getAwardDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.getAwardDetails(action.payload.data, token)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_AWARD_DETAILS_SUCCESS,
        payload: {
          details: response.data.data,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: GET_AWARD_DETAILS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_AWARD_DETAILS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* addAwardNominationWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.addAwardNomination(
      action.payload.data,
      token
    )

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: ADD_AWARD_NOMINATION_SUCCESS,
        payload: {
          details: response.data.data,
          enc_award_nomination_id: response.data.enc_award_nomination_id,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: ADD_AWARD_NOMINATION_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: ADD_AWARD_NOMINATION_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* createOrderAwardNominationWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.createOrderAwardNomination(action.payload.data, token)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: CREATE_ORDER_AWARD_NOMINATION_SUCCESS,
        payload: {
          data: response.data.order,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: CREATE_ORDER_AWARD_NOMINATION_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: CREATE_ORDER_AWARD_NOMINATION_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* verifyAwardNominationPaymentWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.verifyAwardNominationPayment(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS,
        payload: {
          data: response.data.category || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* addAwardShortlistedDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.addAwardShortlistedDetails(
      action.payload.data,
      token
    )

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS,
        payload: {
          details: response.data.data,
          enc_award_nomination_id: response.data.enc_award_nomination_id,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: ADD_AWARD_SHORTLISTED_DETAILS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: ADD_AWARD_SHORTLISTED_DETAILS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// ADMIN

export function* getAwardsListWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.getAwardsList(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_AWARDS_LIST_SUCCESS,
        payload: {
          data: response.data.awardList || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: GET_AWARDS_LIST_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_AWARDS_LIST_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* getNominationListWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.getNominationList(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_NOMINATION_LIST_SUCCESS,
        payload: {
          data: response.data.awards || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: GET_NOMINATION_LIST_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_NOMINATION_LIST_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* getNominationDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.getNominationDetails(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_NOMINATION_DETAILS_SUCCESS,
        payload: {
          data: response.data.data || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: GET_NOMINATION_DETAILS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_NOMINATION_DETAILS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* getAwardsCategoryListWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.getAwardsCategoryList(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_AWARDS_CATEGORY_LIST_SUCCESS,
        payload: {
          data: response.data.awardCategory || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: GET_AWARDS_CATEGORY_LIST_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_AWARDS_CATEGORY_LIST_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* updateNominationWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.updateNomination(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_NOMINATION_SUCCESS,
        payload: {
          message: response.message,
        },
      })
    } else {
      yield put({
        type: UPDATE_NOMINATION_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_NOMINATION_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* addAwardWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.addAward(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: ADD_AWARD_SUCCESS,
        payload: {
          message: response.data.message,
        },
      })
    } else {
      yield put({
        type: ADD_AWARD_FAILURE,
        payload: { message: response.data?.message || "Failed to add award" },
      })
    }
  } catch (error) {
    yield put({
      type: ADD_AWARD_FAILURE,
      payload: { message: error.message },
    })
  }
}

export function* updateAwardWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.updateAward(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_AWARD_SUCCESS,
        payload: {
          message: response.data.message,
        },
      })
    } else {
      yield put({
        type: UPDATE_AWARD_FAILURE,
        payload: { message: response.data?.message || "Failed to update award" },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_AWARD_FAILURE,
      payload: { message: error.message },
    })
  }
}

export function* addAwardCategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.addAwardCategory(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: ADD_AWARD_CATEGORY_SUCCESS,
        payload: { message: response.data.message },
      })
    } else {
      yield put({
        type: ADD_AWARD_CATEGORY_FAILURE,
        payload: { message: response.data?.message || "Failed to add category" },
      })
    }
  } catch (error) {
    yield put({
      type: ADD_AWARD_CATEGORY_FAILURE,
      payload: { message: error.message },
    })
  }
}

export function* updateAwardCategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield awardsApi.updateAwardCategory(action.payload.data, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_AWARD_CATEGORY_SUCCESS,
        payload: { message: response.data.message },
      })
    } else {
      yield put({
        type: UPDATE_AWARD_CATEGORY_FAILURE,
        payload: { message: response.data?.message || "Failed to update category" },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_AWARD_CATEGORY_FAILURE,
      payload: { message: error.message },
    })
  }
}
